import { lazy } from "react";

const RELOAD_KEY = "chunk-reload-at";
// A second chunk failure inside this window means the reload didn't fix it
// (real outage, not a stale tab), so the error is surfaced instead of looping.
const RELOAD_GUARD_MS = 10000;

export const isChunkLoadError = (error) =>
  !!error &&
  (error.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk [^\s]+ failed/i.test(error.message || ""));

const recentlyReloaded = () => {
  try {
    const at = Number(window.sessionStorage.getItem(RELOAD_KEY));
    return at && Date.now() - at < RELOAD_GUARD_MS;
  } catch (e) {
    return false;
  }
};

const markReloaded = () => {
  try {
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // no storage: reload anyway, the next failure just can't be rate limited
  }
};

/**
 * React.lazy for route chunks. Each deploy replaces the hashed chunk files
 * (`aws s3 sync --delete`), so a tab opened before the deploy asks for chunks
 * that no longer exist. Reload once to pick up the new index.html and chunk names.
 */
const lazyWithReload = (factory) =>
  lazy(() =>
    factory().catch((error) => {
      if (isChunkLoadError(error) && !recentlyReloaded()) {
        markReloaded();
        window.location.reload();
        // Keep Suspense on its fallback until the page goes away.
        return new Promise(() => {});
      }
      throw error;
    }),
  );

export default lazyWithReload;
